import { render, staticRenderFns } from "./InputUserId.vue?vue&type=template&id=2bb340f6&"
import script from "./InputUserId.vue?vue&type=script&lang=ts&"
export * from "./InputUserId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports